import React from 'react';
import './LandingPage.css';

const features = [
    {
        icon: '🗂️',
        title: 'Organize Your Day',
        desc: 'Sort your life into color-coded buckets for easy management.'
    },
    {
        icon: '✅',
        title: 'Track Habits & Goals',
        desc: 'Add tasks and habits to buckets and watch your progress.'
    },
    {
        icon: '🎉',
        title: 'Celebrate Achievements',
        desc: 'Earn points and see your growth every day.'
    },
    {
        icon: '🔒',
        title: 'Secure & Fast',
        desc: 'Sign in with Google and access your data anywhere. We don\'t store your personal data—your info stays securely in your own Google account.'
    },
    {
        icon: '📅',
        title: 'Google Workspace Integration',
        desc: 'Connects with your Google Tasks and Calendar (with permission) to organize work, personal, and life events in one place.'
    },
    {
        icon: '⚖️',
        title: 'Life Balance, Not Just To-Dos',
        desc: 'Achieve balance and purpose—organize your whole life, not just a laundry list of tasks.'
    },
    {
        icon: '🚀',
        title: 'Proactive & Purpose-Oriented',
        desc: 'Plan your days and goals with intention, so you don\'t get lost in endless to-dos.'
    },
    {
        icon: '🌈',
        title: 'Visual Progress & Motivation',
        desc: 'Color-coded buckets, points, and achievements make progress visible and rewarding.'
    },
    {
        icon: '🛠️',
        title: 'Customizable for Your Life',
        desc: 'Create buckets for any area—work, health, relationships, hobbies—so your system fits your unique life.'
    },
    {
        icon: '🤖',
        title: 'AI-Powered Advice',
        desc: 'Get personalized tips and guidance from an AI agent to help you stay organized and reach your goals.'
    }
];

export default function LandingPage({ handleLogin }) {
    return (
        <div className="landing-page">
            <header className="lp-header">
                <div className="lp-logo">Life Buckets</div>
                <nav className="lp-nav">
                    <a href="#features">Features</a>
                    <a href="#how">How It Works</a>
                    <a className="lp-cta" onClick={handleLogin}>Sign Up / Login</a>
                </nav>
            </header>
            <section className="lp-hero">
                <h1>Organize Your Life, One Bucket at a Time</h1>
                <p>Life Buckets helps you track habits, goals, and daily tasks in a fun, simple way.</p>
                <a href="#login" className="lp-cta-main">Get Started</a>
                <a href="#features" className="lp-cta-secondary">Learn More</a>
            </section>
            <section id="features" className="lp-features">
                <h2>Features</h2>
                <div className="lp-features-list">
                    {features.map(f => (
                        <div className="lp-feature" key={f.title}>
                            <span className="lp-feature-icon">{f.icon}</span>
                            <h3>{f.title}</h3>
                            <p>{f.desc}</p>
                        </div>
                    ))}
                </div>
            </section>
            <section className="lp-how" id="how">
                <h2>How It Works</h2>
                <ol>
                    <li><strong>Sign Up or Log In:</strong> Use Google to get started instantly.</li>
                    <li><strong>Create Buckets:</strong> Make categories for Mind, Body, Work, Fun, and more.</li>
                    <li><strong>Add Luckets:</strong> Fill buckets with tasks, habits, or goals.</li>
                    <li><strong>Track & Celebrate:</strong> Mark items complete and see your progress.</li>
                </ol>
            </section>
            <footer className="lp-footer">
                <div>© {new Date().getFullYear()} Life Buckets</div>
                <nav>
                    <a href="#privacy">Privacy Policy</a>
                    <a href="#terms">Terms</a>
                    <a href="#contact">Contact</a>
                </nav>
            </footer>
        </div>
    );
}
